var _document_querySelectorAll;
import tippy from 'tippy.js';
(_document_querySelectorAll = document.querySelectorAll('[data-tippy]')) === null || _document_querySelectorAll === void 0 ? void 0 : _document_querySelectorAll.forEach(function($item) {
    tippy($item, {
        animation: 'shift-away',
        maxWidth: '14.2rem',
        placement: 'bottom',
        trigger: 'mouseenter click',
        zIndex: 9999
    });
});
